// DEVELOPMENT
//export const baseUrl = window.location.origin;
//export const compName = "Charles & Keith";
//export const appName = "CKONE";
//export const appSubName = "DEV";
//export const apiDomain = "https://ckoneapi-dev.e-charleskeith.com/api/v1";
//export const apiDomain = "http://127.0.0.1:5001/api/v1";
//export const apiDomain = "https://ckoneapi.e-charleskeith.com/api/v1";
//export const apiDomain = "https://ckone-api.e-charleskeith.com:8443/ck-repl-api";


// PRODUCTION
export const baseUrl = window.location.origin;
export const compName = "Charles & Keith";
export const appName = "CKONE";
export const appSubName = "";
export const apiDomain = "https://ckoneapi.e-charleskeith.com/api/v1";



// WEBPACK FOOTER //
// ./src/.env.js